import { render, staticRenderFns } from "./IssueTypeList.vue?vue&type=template&id=56464a07"
import script from "./IssueTypeList.vue?vue&type=script&lang=js"
export * from "./IssueTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports